/**
 * Retourne vrai si la carte doit être affichée.
 */
export default function roomDisplayMap({ room }) {
  return room.displayMap;
}
